// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"686":"bfab7a0e","963":"64e97907"}[chunkId] + ".chunk.css";
};